import CalendarGroupType from 'owa-service/lib/contract/CalendarGroupType';
import type CalendarPickerScenarioId from '../store/schema/CalendarPickerScenarioId';
import { getCalendarGroups, getCalendarGroupKey } from 'owa-calendar-cache';
import getCalendarPickerStore from '../selectors/getCalendarPickerStore';
import { mutatorAction } from 'satcheljs';

const setIsCreatingCalendar = mutatorAction(
    'setIsCreatingCalendar',
    (
        scenarioId: CalendarPickerScenarioId,
        isCreatingCalendar: boolean,
        userIdentity: string,
        calendarGroupId?: string
    ) => {
        const store = getCalendarPickerStore(scenarioId);
        if (isCreatingCalendar) {
            if (!calendarGroupId) {
                /* There are two ways to create a new calendar
                1. isCreatingCalendar is true when 'new calendar' is triggered from right click context menu
                2. newCalendar is true when 'new calendar' is triggered from the entrypoint under calendar groups.
                With option 2, one can only create new calendar under the 'My calendars' group */
                const [filtered] = getCalendarGroups().filter(
                    g => g.GroupType === CalendarGroupType.MyCalendars
                );

                calendarGroupId = filtered.calendarGroupId.id;
            }

            store.newCalendarInCalendarGroup = getCalendarGroupKey(userIdentity, calendarGroupId);
        } else {
            store.newCalendarInCalendarGroup = null;
        }
    }
);

export function startedCreatingCalendar(
    scenarioId: CalendarPickerScenarioId,
    userIdentity: string,
    calendarGroupId?: string
) {
    setIsCreatingCalendar(scenarioId, true, userIdentity, calendarGroupId);
}

export function stoppedCreatingCalendar(
    scenarioId: CalendarPickerScenarioId,
    userIdentity,
    calendarGroupId?: string
) {
    setIsCreatingCalendar(scenarioId, false, userIdentity, calendarGroupId);
}
